import { useQuery } from '@apollo/client';
import { QueryFreightServiceAcom, QueryBuyTogetherServiceAcom } from '../queries/freight.graphql';
import { getProductQty } from '../queries/product.graphql';
import { fmtFreightProducts } from '../helpers/freight';

export const useFreight = ({ cep, currentSku, dispatchMetrics, skip, cache, fetchPolicy = 'network-only' }) => {
  const { data: vip } = useQuery(QueryBuyTogetherServiceAcom);
  const productQty = useQuery(getProductQty).data?.productQty;
  const products = fmtFreightProducts(currentSku, vip, productQty);
  const { loading, data, error } = useQuery(QueryFreightServiceAcom, {
    variables: {
      cep,
      products,
    },
    onCompleted: /* istanbul ignore next */ data => {
      dispatchMetrics && dispatchMetrics('freight:event', data);
    },
    errorPolicy: 'ignore',
    skip: !cep || skip,
    fetchPolicy: cache ? 'cache-only' : fetchPolicy,
    ssr: false,
  });

  return { loading, data, error };
};
